import { api } from "@/APIRequests";
import type { PatientMedicalCautionsResponse } from "@/core/types";

export async function getMedicalCautions(
  patientId: string,
): Promise<PatientMedicalCautionsResponse> {
  return api.carePlanTyped.get_patient_medical_cautions({
    params: { showLoader: false },
    patientId,
  });
}
